import { useEffect, useState } from "react";
import { Check, BadgeCheck, ShieldCheck, Lock, Undo2, ArrowRight, Gauge, LineChart } from "lucide-react";

export const BENEFITS = ["Free beta", "Lifetime founding price", "Personal shop audit"];
export const TRUST_POINTS = [
  [BadgeCheck, "Official Etsy API"],
  [ShieldCheck, "Nothing changes without your approval"],
  [Lock, "Bestsellers locked"],
  [Undo2, "One-click undo"],
];

export const USP_CHIPS = [
  [Lock, "Bestseller Shield"],
  [ShieldCheck, "Approve every change"],
  [Undo2, "One-click undo"],
  [Gauge, "Health Score for every listing"],
  [LineChart, "Proof in your own numbers"],
  [BadgeCheck, "Official Etsy API"],
];

export const UspChips = ({ testid, className = "" }) => (
  <ul data-testid={testid} className={`flex flex-wrap justify-center gap-2 ${className}`}>
    {USP_CHIPS.map(([Icon, label]) => (
      <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-[12.5px] text-foreground/85 backdrop-blur-md">
        <Icon className="h-3.5 w-3.5 text-[#5EE6D0]" />{label}
      </li>
    ))}
  </ul>
);

export const FoundingBenefits = ({ testid, className = "", center = true }) => (
  <ul data-testid={testid} className={`flex flex-wrap gap-x-5 gap-y-2 text-[13px] sm:text-sm text-[#F3DDAE] ${center ? "justify-center" : ""} ${className}`}>
    {BENEFITS.map((b) => (
      <li key={b} className="inline-flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-[#E9C98B]" />{b}</li>
    ))}
  </ul>
);

export const TrustPoints = ({ testid, className = "" }) => (
  <ul data-testid={testid} className={`flex flex-wrap justify-center gap-x-5 gap-y-2 text-[13px] text-muted-foreground ${className}`}>
    {TRUST_POINTS.map(([Icon, label]) => (
      <li key={label} className="inline-flex items-center gap-1.5"><Icon className="h-3.5 w-3.5 text-[#5EE6D0]" />{label}</li>
    ))}
  </ul>
);

export const scrollToWaitlist = () => {
  document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth", block: "center" });
  setTimeout(() => document.getElementById("wl-email")?.focus({ preventScroll: true }), 600);
};

// Mobile-only: appears once the hero has scrolled out, hides while any waitlist form is on screen.
export const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const seen = new Map();
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => seen.set(e.target, e.isIntersecting));
      setShow(![...seen.values()].some(Boolean));
    });
    document.querySelectorAll('[data-testid="hero"], #waitlist, [data-testid="closing-cta"]').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return (
    <div className={`fixed inset-x-4 bottom-4 z-40 transition-[opacity,transform] duration-300 sm:hidden ${show ? "opacity-100 translate-y-0" : "pointer-events-none translate-y-3 opacity-0"}`}
      aria-hidden={!show} data-testid="sticky-cta">
      <button type="button" tabIndex={show ? 0 : -1} onClick={scrollToWaitlist} data-testid="sticky-cta-button"
        className="btn-aurora inline-flex h-12 w-full items-center justify-center gap-1.5 rounded-full text-[15px] font-medium shadow-[0_12px_40px_-8px_rgba(0,0,0,0.8)]">
        Join the founding list<ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};
